<!--
  Honitby - doplňková mapová nástrojová nabídka 
-->
<template>

  <div class="d-flex flex-row" v-if="MapLayer_Nli_Mysl_visible">

    <v-card height="64" width="282" color="info" class="MapPnlGrdItem elevation-5">
      <v-autocomplete v-model="HoniSearch_Suggest_model" class="mb-3 mx-4" :items="HoniSearch_Suggest_items"
        :loading="HoniSearch_Suggest_isLoading" :search-input.sync="HoniSearch_Suggest_search" hide-details="true"
        hide-no-data item-text="userData.suggestFirstRow" item-value="userData.bbox"
        label="Vyhledat honitbu podle kódu nebo názvu" prepend-icon="mdi-map-search" clearable hide-selected return-object
        :filter="HoniSearch_Filter">
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title v-text="item.userData.suggestFirstRow"></v-list-item-title>
            <v-list-item-subtitle v-text="item.userData.suggestSecondRow"></v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-autocomplete>
    </v-card>

  </div>
</template>

<script>

export default {

  components: {

  },


  props: {
    // Adresa na Assets
    AssetsUrl: null,
    // Mapa (Luciad)
    MAP: Object,
    // Měřítko vztažené k rovníku
    MapScale: null,
    // Mapové vrstvy
    MapLegendLayers: null,
    // Jméno zobrazené dynamické legendy
    MapLayerLegendDynamic_content: {},

    // webová služba
    ServiceMap: null,
  },

  data() {
    return {
      // Jestli je nástroj inicializován
      IsInit: false,


      // Vybraná položka
      HoniSearch_Suggest_model: null,
      // Seznam položek
      HoniSearch_Suggest_items: [],
      // Načítám z webu
      HoniSearch_Suggest_isLoading: false,
      // hledám
      HoniSearch_Suggest_search: null,

      // Vybrané prvky legendy
      VybLegList: [],

      // Viditelnost legendy
      ViewLeg: false,


    };
  },



  computed: {
    // Vrstva dopravy
    MapLayer_Nli_Mysl: function () {
      return this.MapLegendLayers.find((item) => item.id == "Nli_Mysl");
    },
    // Vrstva dopravy - viditelnost
    MapLayer_Nli_Mysl_visible: function () {
      return   this.MapLayer_Nli_Mysl.layer.visible
    },


  },

  watch: {

    // Hledat výraz - suggest
    HoniSearch_Suggest_search(value) {
      // if (value.length > 2) {
      this.HoniSearch_Suggest_isLoading = true;

      this.ServiceMap.SuggestHoni(value)
        .then((response) => {
          if (response.data.Navrh == null) {
            this.HoniSearch_Suggest_items = [];
            this.HoniSearch_Suggest_isLoading = false;
          } else {
            this.HoniSearch_Suggest_items = response.data.Navrh;
            this.HoniSearch_Suggest_isLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.HoniSearch_Suggest_items = [];
          this.HoniSearch_Suggest_isLoading = false;
        })
        .then(function () {
          // always executed
        });
      // }
    },

    // Výběr položky - find a zoom
    HoniSearch_Suggest_model(value) {
      if (value !== null && typeof value !== "undefined") {
        // console.log("MapSearch_Suggest_model");
        // console.log(value);

        this.MapViewZoomToMbr({
          epsg: "EPSG:5514",
          xmin: value.userData.bbox.Xmin,
          ymin: value.userData.bbox.Ymin,
          xmax: value.userData.bbox.Xmax,
          ymax: value.userData.bbox.Ymax,
        })


      }
    },


  },

  methods: {

    // Filtrování položek
    HoniSearch_Filter: function (item, queryText, itemText) {
      // výchozí je následující funkce
      itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
      // Jenže pak se nezobrazí položky, které mají jiný text
      // např. když pošlu na vyhledávač Mapy.cz
      // '50.2233361N 14.8512964E' vyhledá se '50°13'24.01"N 14°51'4.667"E
      // jenže ten se pak přes tento filtr nedostane, má jiný text
      // pro vyhledávání na MapyCz nás vlastně tento filtr nezajímá, chceme zobrazit vše, co jejich fukce vrátí
      // Uvedené platilo pro MapyCz, ale i pro CUZK se prostě zobrazí vše, co se vrátí, nic se nefiltruje.
      return true;
    },

    // Změna mapového výřezu podle obdelníku
    MapViewZoomToMbr: function (value) {
      this.$emit('MapViewZoomToMbr', value);
    },



  },

  mounted() {
    // První spuštění nástroje
    //console.log("Honi start");


    // Objekt aktivován
    this.MAP.layerTree.whenReady().then(() => { this.IsInit = true; })



  },
};
</script>